import React from 'react'
import SubNavbar from '../Components/Layout/SubNavbar'
import ActivityContainer from '../Components/Activity/ActivityContainer'



const ActivityPage = () => {

    return (
        <>
            <SubNavbar />

            <main className="site-content" id="main" style={{ paddingTop: "40px" }}>
                <div className=" ">
                    <div className="container container-two">


                        <div className="tab-content">

                            <div className="activity-wrapper">
                                <ActivityContainer />
                            </div>
                        </div>


                    </div>
                </div>
            </main>
        </>
    )
}

export default ActivityPage